import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import {
  matchPropTypes,
  breadcrumbsPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import { INCIDENT_RECORD_TYPE } from '../../../../config/constants';
import EnumStatus from '../../../common/EnumStatus';
import { getItineraryIncidentById } from '../../../../actions/supervision-control/IncidentRecord';
import { AGENCY_INCIDENT_PATH } from '../../../../config/paths';

const AgencyIncidentRecord = ({
  match: {
    params: { incidentRecordId },
  },
  dispatchGetItineraryIncidentById,
  breadcrumbs,
  loading,
  incidentRecord,
}) => {
  useLayoutEffect(() => {
    dispatchGetItineraryIncidentById({ incidentRecordId });
  }, []);

  const groupAnswersByTree = (answers) => {
    const trees = [];
    const roots = answers.filter((a) => a.parentId === null);

    roots.forEach((root) => {
      const children = answers.filter((a) => a.parentId === root.nodeId);
      trees.push({ root, children });
    });

    return trees;
  };

  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (incidentRecord.isEmpty()) {
    content = <NoDataResource returnPage={AGENCY_INCIDENT_PATH} />;
  } else {
    const incidentRecordJS = incidentRecord.toJS();
    const { answers, userFullName, incidentDate, incidentRecordType } =
      incidentRecordJS;

    const trees = groupAnswersByTree(answers);

    content = (
      <>
        <ResourceProperty label="Usuario:">{userFullName}</ResourceProperty>
        <ResourceProperty label="Tipo de Registro:">
          <EnumStatus
            enumValue={incidentRecordType}
            enumObject={INCIDENT_RECORD_TYPE}
          />
        </ResourceProperty>
        <ResourceProperty label="Fecha del Incidente:">
          {tzNormalizeDate({ date: incidentDate, format: DATE_TIME_FORMAT })}
        </ResourceProperty>

        <h4>Selecciones</h4>

        {trees.map(({ root, children }) => (
          <div key={root.nodeId} style={{ marginBottom: '1rem' }}>
            <ResourceProperty label={`${root.label}:`}>
              <ul style={{ marginBottom: 0 }}>
                {children.map((child) => (
                  <li key={child.nodeId}>{child.label}</li>
                ))}
              </ul>
            </ResourceProperty>

            {[root, ...children].map((answer) =>
              answer.note ? (
                <ResourceProperty
                  key={answer.nodeId}
                  label={`Nota (${answer.label}):`}
                >
                  {answer.note}
                </ResourceProperty>
              ) : null,
            )}
          </div>
        ))}
      </>
    );
  }

  return (
    <Content
      title="Detalle del Registro de Incidente"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  );
};

AgencyIncidentRecord.propTypes = {
  match: matchPropTypes.isRequired,
  dispatchGetItineraryIncidentById: PropTypes.func.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  incidentRecord: PropTypes.instanceOf(Immutable.Map),
};

AgencyIncidentRecord.defaultProps = {
  loading: false,
  incidentRecord: Immutable.Map(),
};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Incidentes de Agencia',
      href: AGENCY_INCIDENT_PATH,
    },
    {
      text: 'Incidente',
      href: '',
    },
  ],
  loading: SupervisionControlUnit.IncidentRecord.getIn([
    'incidentRecord',
    'loading',
  ]),
  incidentRecord: SupervisionControlUnit.IncidentRecord.getIn([
    'incidentRecord',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItineraryIncidentById: getItineraryIncidentById,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AgencyIncidentRecord);
